import { useNavigate } from "react-router-dom";
import { PlanType } from "sdk/types";
import { routes } from "~/constants";
import { useAuthN } from "~/hooks/useAuthN";
import { useCurrentUserUpdateMutation } from "~/store/api";
import { buildPlanDetailsMap } from "../utils";
import { MembershipSelectAction } from "./useGetMembershipSelectAction";

interface UseGetPlanDetailsMap {
  action: MembershipSelectAction;
  handleClick: () => void;
  type: PlanType;
}

export const useGetPlanDetailsMap = ({
  action,
  handleClick,
  type,
}: UseGetPlanDetailsMap) => {
  const [apiCurrentUserUpdate] = useCurrentUserUpdateMutation();
  const { handleSetUser } = useAuthN();
  const navigate = useNavigate();

  const handleUpgradeClick = async (): Promise<void> => {
    const values = {
      plan: "premium",
    } as const;

    const responseBody = await apiCurrentUserUpdate(values).unwrap();
    const currentUser = responseBody.data.attributes;

    navigate(routes.confirmation, { state: { upgrade: true } });
    handleSetUser(currentUser);
    handleClick();
  };

  return buildPlanDetailsMap({
    action,
    handleClick,
    handleUpgradeClick,
    type,
  });
};
